<template>
<div class="chapter">
<div class="inner_page">
<h6 class="sub-title"><a id="page_ii"></a>To Miker</h6>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780857901729_02_ded.vue?66be5bde